import { observer } from 'mobx-react-lite'
import { DropdownContent, Scrollbar } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'
import { CustomItem } from './customItem'
import { MemberItem } from './memberItem'
import styles from './styles.module.scss'

type IBroadcastAssigneeDropdownContentProps = {
  onCloseMenu: () => void
}

export const BroadcastAssigneeDropdownContent = observer(
  ({ onCloseMenu }: IBroadcastAssigneeDropdownContentProps) => {
    const {
      broadcastAssigneeStore: {
        assignedMemberId,
        search,
        setSearch,
        filteredMemberItems,
        filteredCustomItems,
        setAssignMemberId,
      },
    } = useBroadcastViewContext()

    return (
      <DropdownContent noPadding>
        <div className={styles.dropdownWrapper}>
          <div className={styles.searchWrapper}>
            <TextField
              size='small'
              variant='integrated'
              InputProps={{
                placeholder: 'Search',
              }}
              value={search}
              onChange={setSearch}
              mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
            />
          </div>
          <Scrollbar autoHeightMin={0} autoHeightMax={200} autoHeight={true}>
            <div className={styles.membersWrapper}>
              {filteredCustomItems.map((item) => (
                <CustomItem
                  onClose={onCloseMenu}
                  active={assignedMemberId === item.id}
                  key={item.id}
                  item={item}
                  onReassign={setAssignMemberId}
                />
              ))}

              {filteredMemberItems.map((member) => (
                <MemberItem
                  onClose={onCloseMenu}
                  active={assignedMemberId === member.id}
                  key={member.id}
                  member={member}
                  onReassign={setAssignMemberId}
                />
              ))}
            </div>
          </Scrollbar>
        </div>
      </DropdownContent>
    )
  }
)
